import {
	apiAppAdminReleasenoteGetreactions,
	apiAppAdminReleasenoteSave,
	apiAppAppReleasenoteMarkasread,
	apiAppAppReleasenoteReact,
	type ReleaseNote,
	type ReleaseNoteReaction,
	type ReleaseNoteReactionType,
	type User
} from '#lib/types/generated/index.js';
import { derived, get, writable } from 'svelte/store';
import { adminStore } from './admin';
import { now } from './time';
import { userStore } from './user';

export const releaseNoteStore = writable<ReleaseNote[]>([]);
export const releaseNotesPanelStore = writable<boolean>(false);

let isMarkingAsRead = false;

export function markAsRead(): Promise<void> | undefined {
	if (isMarkingAsRead) {
		return;
	}
	isMarkingAsRead = true;
	return apiAppAppReleasenoteMarkasread()
		.then(() => {
			const backupAdminStore = get(adminStore);
			userStore.update((u) => ({
				...u,
				releaseNotesReadAt: get(now)
			}));
			adminStore.set(backupAdminStore);
		})
		.finally(() => {
			isMarkingAsRead = false;
		});
}

export function react(
	noteId: number,
	reaction: ReleaseNoteReactionType | null
): Promise<void> | undefined {
	return apiAppAppReleasenoteReact(noteId, { reaction }).then((res) => {
		if (res.success && res.reactions) {
			releaseNoteStore.update((notes) =>
				notes.map((note) => {
					if (note.id === noteId) {
						return {
							...note,
							reactions: res.reactions!,
							userReaction: res.userReaction as ReleaseNoteReactionType | null
						};
					}
					return note;
				})
			);
		}
	});
}

export async function saveReleaseNoteAdmin(note: ReleaseNote): Promise<ReleaseNote> {
	const publishedAt = note.publishedAt.toISO();
	if (!publishedAt) {
		throw new Error('Missing publishedAt on release note');
	}

	return apiAppAdminReleasenoteSave({
		id: note.id,
		title: note.title,
		description: note.description,
		type: note.type,
		link: note.link,
		publishedAt
	});
}

export async function fetchReleaseNoteReactionsAdmin(
	noteId: number
): Promise<ReleaseNoteReaction[]> {
	const res = await apiAppAdminReleasenoteGetreactions(noteId);
	return res.items;
}

export const hasNewReleasesUpdate = derived(
	[releaseNoteStore, userStore],
	([$releaseNoteStore, $userStore]: [ReleaseNote[], User]) => {
		return (
			$releaseNoteStore.length > 0 &&
			$releaseNoteStore[0].publishedAt > $userStore.releaseNotesReadAt
		);
	}
);
